import { entity, list } from "./base";
import { concatModules } from "@/utility";
import utility from "@/utility";

const initialEntity = {

};

const requestEntityModule = {
  state: {
    open: false,
    pk: null,
    freeTextOpen: false,
    freeTextPk: null,
    freeText: null,
    processingFreeText: false,
  },
  mutations: {
    open(state, {pk}) {
      state.open = true;
      state.pk = pk;
    },
    openFreeText(state, {pk}) {
      state.freeTextOpen = true;
      state.freeTextPk = pk;
    },
    close(state) {
      state.open = false;
      state.pk = null;
      state.processing = false;
      state.error = false;
      state.errorMessages = [];
    },
    freeTextClose(state) {
      state.freeTextOpen = false;
      state.freeTextPk = null;
      state.processingFreeText = false;
    },
    freeText(state, payload) {
      state.freeText = payload.value;
      state.processingFreeText = false;
    },
    processingFreeText(state) {
      state.processingFreeText = true;
    }
  },
  actions: {
    showFreeText({ commit }, { pk }) {
      commit("processingFreeText");
      return new Promise((resolve, reject) => {
        this.$axios // axios
          .get(`/requests/freetext/${pk}`) // get
          .then((response) => {
            commit("freeText", {
              value: response.data.data
            });

            resolve();
          })
          .catch((error) => {
            commit("failed", { error });
            reject(error);
          });
      });
    },
    updateFreeText({ commit }, { pk, value, formKeys = [] }) {
      const store = this;

      commit("processingFreeText");

      return new Promise((resolve, reject) => {
        store.$axios
          .put(`requests/freetext/${pk}`, {
            value: value
          })
          .then(() => {
            commit("freeTextClose");
            resolve();
          })
          .catch((error) => {
            commit("failed", { error });
            reject(error);
          });
      });
    }
  },
  getters: {
    open(state) {
      return state.open;
    },
    pk(state) {
      return state.pk;
    },
    freeTextOpen(state) {
      return state.freeTextOpen;
    },
    freeTextPk(state) {
      return state.freeTextPk;
    },
    freeText(state) {
      return state.freeText;
    },
    processingFreeText(state) {
      return state.processingFreeText;
    }
  }
};

const requestListModule = {
  state: {
  },
  mutations: {
  },
  actions: {
    shipped({ commit }, { ids}) {
      const store = this;

      commit("processing");

      return new Promise((resolve, reject) => {
        store.$axios // axios
          .put(`/requests/shipped`, {
            params: {
              ids,
              status
            }
          }) // delete
          .then(() => {
            commit("processed");


            utility.$message({
              type: "success",
              message: "出荷済みに切り替えました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("processed");
            commit("failed", { error });

            reject(error);
          });
      });
    },
    removeShipped({ commit }, { ids}) {
      const store = this;

      commit("processing");

      return new Promise((resolve, reject) => {
        store.$axios // axios
          .put(`/requests/remove_shipped`, {
            params: {
              ids,
              status
            }
          }) // delete
          .then(() => {
            commit("processed");


            utility.$message({
              type: "success",
              message: "出荷済み状態を取り消しました",
              showClose: true,
              customClass: "el-message-content-position"
            });

            resolve();
          })
          .catch((error) => {
            commit("processed");
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {
  }
};

const entityModule = entity("requests", initialEntity);
const listModule = list("requests");

export const requests = {
  namespaced: true,
  modules: {
    list: concatModules(listModule, requestListModule),
    entity: concatModules(entityModule, requestEntityModule)
  }
};
